import { AttributeKey } from '@ps/poker-games-tile-mappers';
import React from 'react';

import type { HGPokerGameTile } from '@swf/core/types/Poker';

import SelectGame from '../../PokerGameTile/SelectGame/SelectGame';
import Attribute from '../Attribute/Attribute';
import BuyInIcon from '../assets/buy-in.svg';
import PlayersIcon from '../assets/players.svg';
import PrizePoolIcon from '../assets/prize.svg';
import StakesIcon from '../assets/stakes.svg';

import styles from './Footer.scss';
import useArrangeAttributes from './useArrangeAttributes';

interface Props {
  attributes: HGPokerGameTile['attributes'];
  tableName?: HGPokerGameTile['name'];
  maxPlayers?: HGPokerGameTile['maxPlayers'];
  isSmallDevice: boolean;
  canSelect: boolean;
  id: HGPokerGameTile['id'];
}

const attributeIconMap = {
  [AttributeKey.buyIn]: <BuyInIcon />,
  [AttributeKey.prizePool]: <PrizePoolIcon />,
  [AttributeKey.players]: <PlayersIcon />,
  [AttributeKey.stakes]: <StakesIcon />
};

const Footer: React.FC<Props> = ({
  attributes,
  tableName,
  maxPlayers,
  isSmallDevice,
  canSelect,
  id
}) => {
  const { bottomSectionItems, topSectionItems } = useArrangeAttributes(
    attributes,
    Number(maxPlayers)
  );

  return (
    <div className={styles.container} data-testid="footer">
      {!isSmallDevice && (
        <div className={styles.top}>
          {topSectionItems.map(({ value, key, name }) => (
            <Attribute attributeKey={key} key={key} name={name} value={value} />
          ))}
        </div>
      )}

      <div className={styles.name}>
        {tableName} {canSelect ? <SelectGame id={id} /> : null}
      </div>
      <div className={styles.bottom}>
        {bottomSectionItems.map(({ value, key, name }) => (
          <Attribute
            attributeKey={key}
            name={name}
            key={key}
            value={value}
            icon={attributeIconMap[key]}
            isSmallDevice={isSmallDevice}
          />
        ))}
      </div>
    </div>
  );
};

export default Footer;
